// Fuel Coffeeworks — Theme JS

// Mobile menu
class FuelMobileMenu {
  constructor() {
    this.menu = document.querySelector('.fuel-mobile-menu');
    this.toggle = document.querySelector('.fuel-header__mobile-toggle');
    this.close = document.querySelector('.fuel-mobile-menu__close');
    this.overlay = document.querySelector('.fuel-mobile-menu__overlay');
    if (!this.menu) return;
    this.toggle?.addEventListener('click', () => this.open());
    this.close?.addEventListener('click', () => this.closeMenu());
    this.overlay?.addEventListener('click', () => this.closeMenu());
  }
  open() {
    this.menu.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  closeMenu() {
    this.menu.classList.remove('is-open');
    document.body.style.overflow = '';
  }
}

// Cart drawer
class FuelCartDrawer {
  constructor() {
    this.drawer = document.querySelector('.fuel-cart-drawer');
    this.overlay = document.querySelector('.fuel-cart-drawer__overlay');
    this.closeBtn = document.querySelector('.fuel-cart-drawer__close');
    if (!this.drawer) return;
    document.querySelectorAll('[data-cart-toggle]').forEach(btn => {
      btn.addEventListener('click', () => this.open());
    });
    this.closeBtn?.addEventListener('click', () => this.close());
    this.overlay?.addEventListener('click', () => this.close());
  }
  open() {
    this.drawer.classList.add('is-open');
    this.overlay?.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  close() {
    this.drawer.classList.remove('is-open');
    this.overlay?.classList.remove('is-open');
    document.body.style.overflow = '';
  }
}

// Variant pills
class FuelVariantPills {
  constructor(container) {
    this.container = container;
    this.pills = container.querySelectorAll('.fuel-product-page__pill');
    this.pills.forEach(pill => {
      pill.addEventListener('click', () => {
        if (pill.classList.contains('is-sold-out')) return;
        const group = pill.closest('[data-option-group]');
        group?.querySelectorAll('.fuel-product-page__pill').forEach(p => p.classList.remove('is-active'));
        pill.classList.add('is-active');
      });
    });
  }
}

// Quantity control
class FuelQtyControl {
  constructor(container) {
    container.querySelectorAll('.fuel-cart-item__qty').forEach(qty => {
      const minus = qty.querySelector('[data-qty-minus]');
      const plus = qty.querySelector('[data-qty-plus]');
      const val = qty.querySelector('.fuel-cart-item__qty-val');
      minus?.addEventListener('click', () => {
        const v = parseInt(val.textContent) - 1;
        if (v < 1) return;
        val.textContent = v;
      });
      plus?.addEventListener('click', () => {
        val.textContent = parseInt(val.textContent) + 1;
      });
    });
  }
}

// Add to cart with loading state
document.addEventListener('submit', async (e) => {
  const form = e.target.closest('[data-add-to-cart-form]');
  if (!form) return;
  e.preventDefault();
  const btn = form.querySelector('.fuel-product-page__add-to-cart');
  const original = btn?.textContent;
  if (btn) {
    btn.textContent = 'Adding...';
    btn.disabled = true;
  }
  try {
    const data = new FormData(form);
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      body: data
    });
    if (res.ok) {
      if (btn) btn.textContent = 'Added!';
      setTimeout(() => {
        if (btn) { btn.textContent = original; btn.disabled = false; }
        document.querySelector('.fuel-cart-drawer')?.classList.add('is-open');
        document.querySelector('.fuel-cart-drawer__overlay')?.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      }, 800);
      updateCartCount();
    }
  } catch {
    if (btn) { btn.textContent = original; btn.disabled = false; }
  }
});

async function updateCartCount() {
  const res = await fetch('/cart.js');
  const cart = await res.json();
  document.querySelectorAll('.fuel-header__cart-count').forEach(el => {
    el.textContent = cart.item_count;
    el.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
  });
}

document.addEventListener('DOMContentLoaded', () => {
  new FuelMobileMenu();
  new FuelCartDrawer();
  document.querySelectorAll('[data-variant-pills]').forEach(c => new FuelVariantPills(c));
  new FuelQtyControl(document);
  updateCartCount();
  document.body.classList.add('page-transition');
});
